import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { Observable } from 'rxjs';
import { ClinicalTextTemplateDto } from '../../dtos/clinical-text-template.dto';

@Injectable({ providedIn: 'root' })
export class ClinicalTextTemplatesRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public getAll(): Observable<ClinicalTextTemplateDto[]> {
    return this.http.get<ClinicalTextTemplateDto[]>(`${this.apiUrl}${API_ENDPOINTS.patients.textTemplates}`);
  }
}
